import React, { useState, useRef } from "react";
import Popup from "reactjs-popup";
import SignaturePad from "react-signature-canvas";
import "./css/sigCanvas.css";
import "./css/popup.css";
import {ImageField, ImageInput, useDataProvider, useNotify} from 'react-admin'
import SafeImage, { SIGNATURE_PLACEHOLDER } from './SafeImage'



export const Signature=({...props})=> {
  //console.log(props)

  const pencolor= props && props.pencolor? props.pencolor : 'black';
  const type = props && props.type? props.type : null;
  const sname= props && props.sname? props.sname : null;
  const id = props && props.id? props.id : 0;
  const img_url = props && props.url? props.url : null;
  const minWidth = props && props.minWidth?  props.minWidth : "0.7";
  const maxWidth = props && props.maxWidth?  props.maxWidth : "1.2";

  //console.log(img_url)
  const [imageURL, setImageURL] = useState(img_url); // create a state that will contain our image url
  const sigCanvas = useRef({});
 // const dataProvider = useDataProvider();
  //const notify = useNotify();

  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);


  /* a function that uses the canvas ref to clear the canvas 
  via a method given by react-signature-canvas */
  const clear = () => sigCanvas.current.clear();

  /* a function that uses the canvas ref to trim the canvas 
  from white spaces via a method given by react-signature-canvas
  then saves it in our state */
  const save = () =>{
    setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    props && props.setSignatureValue(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    closeModal(true);
  }

  return (
    <div style={{ border: "0px solid black", backgroundColor: "white"}}>
         <button type="button" className="button" onClick={() => setOpen(o => !o)}>
        Sign
      </button>
    {/*
      The outer guard stays: this is a capture widget, so before the user has
      signed there is genuinely nothing to show and a "NO SIGNATURE ON FILE"
      marker would be noise. SafeImage covers the other case - a signature that
      IS on record but whose URL fails to load, which previously rendered a
      broken-image icon with no indication of what went wrong.
    */}
    {imageURL || img_url? (
        <SafeImage
          src={imageURL? imageURL: img_url? img_url: null}
          fallbackSrc={SIGNATURE_PLACEHOLDER}
          alt="Donor signature"
          className="image"
          name= "donor_signature"
        />
    ) : null}

      <Popup open={open}  onClose={closeModal}  closeOnDocumentClick={false} >
            {close => (
            <>  <p className='pclass'>Sign below</p>
                <SignaturePad
                ref={sigCanvas}
                canvasProps={{
                    className: "signatureCanvas"
                }}
                penColor={(pencolor && pencolor !== '')? pencolor: 'black'}
                minWidth= {minWidth}
                maxWidth= {maxWidth}
                />
                <p />
                {/* Button to trigger save canvas image */}
                <center>
                    <button className='popup-button' onClick={save}>Accept</button>
                    <button className='popup-button'onClick={clear}>Clear</button>
                    <button className='popup-button'onClick={close}>Close</button>
                </center>
            </>
            )}
       
      </Popup>
      
    </div>
  );
}

export default Signature